export default __webpack_public_path__ + "static/media/023-makeup.5314b458.svg";